import React, {useEffect, useState} from 'react';
import CompaniesHero from '../../../features/Components/Companies/CompaniesHero';
import Employees from '../../../features/Components/Companies/Employees';
import InputMUISearch from '../../../shared/InputMUISearch';
import {
  getCompanyEmployeeList,
  patchCompanyEmployeeFire,
  patchCompanyEmployeeReturn
} from '../../../redux/actions/employee/employeeActions';

import {useDispatch, useSelector} from 'react-redux';
import NoItems from '../../Components/NoItems';
import LoadPanel from '../../Components/LoadPanel';
import {notifySuccess} from '../../../helpers/notifySnack';
import {useTranslation} from 'react-i18next';
import './CompaniesEmployees.scss';
import {hasPermission} from '../../../helpers/functions';
import {PERMISSIONS} from '../../../helpers/constants';
import {setModal, setModalData, showConfirmPopup} from '../../../redux/actions/app/appActions';
import {mainPath} from '../../../routes/paths';
import {useHistory} from 'react-router-dom';
import {POPUPS} from '../../../redux/actions/app/appActionTypes';
import {getCompany} from '../../../redux/actions/company/companyActions';

const CompaniesEmployees = () => {
  const {t} = useTranslation();
  const history = useHistory();

  const {singleCompany} = useSelector((state) => state.company);
  const dispatch = useDispatch();
  const {companyEmployeesList, companyEmployeesListLoading} = useSelector((state) => state.employee);
  const profileMe = useSelector((state) => state.profile.profileMe);

  useEffect(() => {
    if (!companyEmployeesList.length && companyEmployeesListLoading) {
      dispatch(getCompanyEmployeeList(singleCompany.id));
    }
  }, [dispatch, singleCompany.id, companyEmployeesListLoading, companyEmployeesList]);

  const [searchCompanies, setSearchCompanies] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    setSearchCompanies(event.target.value);
  };

  const handleClear = () => {
    setSearchCompanies('');
  };

  const handleId = async (id) => {
    history.push(`${mainPath.companiesEmployeesSingle.replace(':id', singleCompany?.id).replace(':employeeId', id)}`);
  };
  const handleBack = () => {
    history.push(mainPath.companiesEmployees.replace(':id', singleCompany?.id));
  };
  const handleAdd = () => {
    history.push(`${mainPath.companiesEmployeesAdd.replace(':id', singleCompany?.id)}`);
  };

  const handleFire = async (employeeId) => {
    setLoading(true);
    try {
      const response = await dispatch(patchCompanyEmployeeFire(singleCompany.id, employeeId));
      if (response.payload?.status === 202) {
        await dispatch(getCompanyEmployeeList(singleCompany.id));
        await dispatch(getCompany(singleCompany.id));
        notifySuccess(t('all.successfully'));
      }
    } finally {
      setLoading(false);
    }
  };

  const handleReturn = async (employeeId) => {
    setLoading(true);
    try {
      const response = await dispatch(patchCompanyEmployeeReturn(singleCompany.id, employeeId));
      if (response.payload?.status === 202) {
        await dispatch(getCompanyEmployeeList(singleCompany.id));
        await dispatch(getCompany(singleCompany.id));
        notifySuccess(t('all.successfully'));
      }
    } catch (error) {
      console.error('Помилка при поверненні співробітника:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFireRedux = (employeeId) => {
    dispatch(
      showConfirmPopup({
        title: t('participant.fireTitle'),
        text: t('participant.fireText'),
        visible: true,
        confirmCallback: () => handleFire(employeeId)
      })
    );
  };

  const handleReturnRedux = (employeeId) => {
    dispatch(
      showConfirmPopup({
        visible: true,
        title: t('participant.returnTitle'),
        text: t('participant.returnText'),
        confirmCallback: () => handleReturn(employeeId)
      })
    );
  };

  const onEditUser = (employeeId) => {
    dispatch(setModal(POPUPS.EDIT_USER));
    dispatch(setModalData(employeeId));
  };

  const filteredEmployees = Array.isArray(companyEmployeesList)
    ? companyEmployeesList.filter((employee) =>
        employee?.firstName?.toLowerCase().includes(searchCompanies?.toLowerCase())
      )
    : [];

  const createPermission = hasPermission(PERMISSIONS.EMPLOYEE_CREATE, profileMe?.permissions ?? []);
  const editPermission = hasPermission(PERMISSIONS.EMPLOYEE_EDIT, profileMe?.permissions ?? []);
  const fireEmployeePermission = hasPermission(PERMISSIONS.EMPLOYEE_FIRE, profileMe?.permissions ?? []);
  const returnEmployeePermission = hasPermission(PERMISSIONS.EMPLOYEE_RETURN, profileMe?.permissions ?? []);
  const editPerson = hasPermission(PERMISSIONS.USER_FULL_EDIT, profileMe?.permissions ?? []);

  if (companyEmployeesListLoading) {
    return (
      <div className={'companies-page-loader'}>
        <LoadPanel noBg={true} circleSize={50} staticPos={true} />
      </div>
    );
  }

  if (loading) {
    return (
      <div className={'companies-page-loader'}>
        <LoadPanel noBg={true} circleSize={50} staticPos={true} />
      </div>
    );
  }

  return (
    <div className='companies-employees-wrapper'>
      <div className='companies-employees'>
        <div className='companies-name'>{singleCompany?.name ?? ''}</div>

        <CompaniesHero
          heading={`${companyEmployeesList.length} ${t('companiesEmployees.headingHero')}`}
          subHeading={t('companiesEmployees.subHeadingHero')}
          selectedAdd={true}
          selectedList={true}
          handleAdd={handleAdd}
          handleList={handleBack}
          disabledActionAdd={!createPermission}
        />

        <>
          {companyEmployeesList.length > 0 ? (
            <div className='companies-employees__content'>
              <InputMUISearch
                className='search-box__input'
                fullWidth
                value={searchCompanies}
                onClear={handleClear}
                onChange={handleChange}
                placeholder={t('companiesEmployees.searchPlaceholder')}
              />

              <div className='companies-employees__list-wrapper'>
                <div className='companies-employees__list'>
                  {filteredEmployees.map(
                    ({id, employeeId, firstName, status, avatar, positionName, mark, projectsAtWork, email, phone}) => (
                      <Employees
                        key={id}
                        name={firstName}
                        position={positionName}
                        status={status}
                        id={id}
                        avatar={avatar}
                        employeeId={employeeId}
                        email={email}
                        mark={mark}
                        projectsAtWork={projectsAtWork}
                        handleId={() => handleId(employeeId)}
                        onFire={handleFireRedux}
                        onReturn={handleReturnRedux}
                        editPermission={editPermission}
                        editPerson={editPerson}
                        phone={phone}
                        onEditUser={onEditUser}
                        fireEmployeePermission={fireEmployeePermission}
                        returnEmployeePermission={returnEmployeePermission}
                      />
                    )
                  )}
                </div>
              </div>
            </div>
          ) : (
            <NoItems
              description={t('companiesEmployees.description')}
              buttonText={t('companiesEmployees.button')}
              title={t('companiesEmployees.title')}
              handleNavigate={handleAdd}
              disabled={!createPermission}
              center={'center'}
            />
          )}
        </>
      </div>
    </div>
  );
};

export default CompaniesEmployees;
